import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Stack from '@mui/material/Stack';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import useMediaQuery from '@mui/material/useMediaQuery';

import { formatChipTagList } from './helpers';

const VpMediaTagsList = ({ tags = [], flexWrap = 'nowrap' }) => {
  const isSmallDesktop = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const [tagList, hiddenTags] = useMemo(
    () => formatChipTagList(tags, isSmallDesktop),
    [tags, isSmallDesktop]
  );
  return (
    <Stack flexWrap={flexWrap} direction="row" gap={1} alignItems="center">
      {tagList?.map((tag) => {
        const isExcessCountChip = tag?.id === 'extra-count';

        return isExcessCountChip ? (
          <Tooltip title={hiddenTags?.map((tag) => ` ${tag.name}`).toString()}>
            <Chip label={tag?.name} key={tag?.id} sx={{ m: 0 }} />
          </Tooltip>
        ) : (
          <Chip label={tag?.name} key={tag?.id} sx={{ m: 0 }} />
        );
      })}
    </Stack>
  );
};

VpMediaTagsList.propTypes = {
  tags: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    })
  ).isRequired,
  flexWrap: PropTypes.oneOf(['wrap', 'nowrap']),
};

export default VpMediaTagsList;



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaTagsList.jsx